import { cn } from "@/lib/cn";
import { initial } from "@/lib/format";

export function Avatar({ name, src, size = "md", round, tone, className, style }: {
  name: string | null | undefined;
  src?: string | null;
  size?: "sm" | "md" | "lg";
  round?: boolean;
  tone?: "ct" | "t";
  className?: string;
  style?: React.CSSProperties;
}) {
  const cls = cn("avatar", size === "sm" && "avatar-sm", size === "lg" && "avatar-lg", round && "avatar-round", tone && `avatar-${tone}`, className);
  if (src) {
    return <img src={src} alt="" className={cn(cls, "object-cover")} style={style} referrerPolicy="no-referrer" />;
  }
  return (
    <span className={cls} style={style} aria-hidden="true">
      {initial(name)}
    </span>
  );
}
